import { Button, styled } from "@mui/material"

import { BUTTON_RADIUS_MULTIPLIER } from "../../themes/defaultThemeParams"

/**
 * Styled button component for use across App. Should be used over generic
 * material UI button component.
 */
const AppButton = styled(Button)(({ theme }) => ({
    borderRadius: theme.shape.borderRadius * BUTTON_RADIUS_MULTIPLIER,
    textTransform: "none",
}))

export default AppButton
